import { render } from "./InSectionTitle.vue?vue&type=template&id=13a7b5ef"
import script from "./InSectionTitle.vue?vue&type=script&lang=js"
export * from "./InSectionTitle.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__